import React, { useState } from 'react';
import { CircularProgress, Grid } from '@mui/material'
import { TextField } from '@mui/material'
import { Button } from '@mui/material'
import { Autocomplete } from '../../../../components/Autocomplete';
import { useToast } from '../../../../hooks/useToast';
import { Formik, Form } from 'formik';
import { useAuth } from "../../../../hooks/useAuth"
import { useQuery, useMutation, QueryClient } from "react-query";
import * as Yup from 'yup';
import { 
        listRoles, 
        listCompanyPermissions, 
        postAddUser, getEdtUser, 
        putEdtUser 
    } from '../../../../services/users'
import { SaveButton } from '../../../../components/SaveButton';

type MyUser = {
    companyId : number,
    name : string,
    email: string,
    password: string,
    confirmPassword: string,
    role: {},
    permissions?: any
};

type props = {
    type?: string,
    idUser: number,
    openModal: () => void,
    queryClient: QueryClient
}

const schema = Yup.object().shape({
    name: Yup.string().required('O nome é obrigatório'),
    email: Yup.string()
      .email('Email inválido')
      .required('O email é obrigatório'),
    role: Yup.number().required('O cargo é obrigatório'),
    permissions: Yup.array().of(
      Yup.object().shape({
        moduleId: Yup.number().required(),
        serviceId: Yup.number().required(),
      })
    ),
    password: Yup.string().min(6, 'A senha tem que ter mais que 6 caractéres.'),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref('password'), null],
      'As senhas estão diferentes.'
    ),
});

export function AddUpdateUser(props: props) {
    const { user } = useAuth();
    const [roles, setRoles] = useState([])
    const [companyPermissions, setCompanyPermissions] = useState();
    const companyId = user.companyId
    const [saveButton, setSaveButton] = useState(false)
    const toast = useToast();
    const [data, setData] = useState<MyUser>(
        {
            companyId : companyId,
            name : '',
            email: '',
            password: '',
            confirmPassword: '',
            role: {},
            permissions: []
        })
    
    const getUser = useQuery("getUser", async () => {
        if(props.type === 'edt'){
            const response : any = await getEdtUser(props.idUser);
            console.log('meu usuario: ',response)
            setData({
                ...response.data,
                role: response.data.role ? response.data.role.roleId : null,
                permissions: response.data.permissions.map((item: any) => ({
                  moduleId: item.module.id,
                  moduleName: item.module.name,
                  serviceId: item.service.id,
                  serviceName: item.service.name,
                })),
              })
        }
    }, {staleTime: 2000, cacheTime: 10});

    const getRoles = useQuery("getRoles", async () => {
        const response : any = await listRoles();
        setRoles(response.data)
        console.log('roles', response.data)
        return response
    }, {staleTime: 2000, cacheTime: 10});

    const getPermissions = useQuery("getPermissions", async () => {
        const response : any = await listCompanyPermissions();
        console.log('response da function: ',response.data)
        setCompanyPermissions(
            response.data.map((item : any) => ({
              moduleId: item.module.id,
              moduleName: item.module.name,
              serviceId: item.service.id,
              serviceName: item.service.name,
            }))
          );
        return response
    }, {staleTime: 2000, cacheTime: 10});


    const postUserSave = useMutation(
        async (data: any) => {
          const response = await postAddUser(data);
          return response;
        },
        {
          onSuccess: async () => {
            await props.queryClient.invalidateQueries("getUsers")
            toast.show("Usuario cadastrado com sucesso!", { severity: "success" });
            props.openModal()
          },
          onError: () => {
            toast.show("Falha ao cadastrar o usuario!", { severity: "error" });
            props.openModal()
          },
        }
    );

    const postUserUpdate = useMutation(
        async (data: any) => {
          const response = await putEdtUser(data, props.idUser);
          return response;
        },
        {
          onSuccess: async () => {
            await props.queryClient.invalidateQueries("getUsers")
            toast.show("Usuario atualizado com sucesso!", { severity: "success" });
            props.openModal()
          },
          onError: () => {
            toast.show("Falha ao atualizar o usuario!", { severity: "error" });
            props.openModal()
          },
        }
    );

    const onSubmit = async (values : any, actions: any)  => {
        setSaveButton((prev) => !prev)
        try {
            if(props.type === 'add'){
                await postUserSave.mutateAsync(values);
            }else{
                await postUserUpdate.mutateAsync(values);
            }
        }catch (err) {
            console.log({ err });
        }
    }

    if (getRoles.isLoading || getPermissions.isLoading || getUser.isLoading) {
        return (
            <Grid container spacing={2} sx={{height: '10rem', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
                <CircularProgress size={24} />
            </Grid>
        );
    }
    
    function updateRoles(idRole: any){
        let objectRole = roles.find((role : any) => idRole === role.id)
        return objectRole
    }

  return (
    <Grid container maxWidth="xl" sx={{paddingTop: '0.5rem'}}>
        <Formik
            initialValues={data}
            onSubmit={onSubmit}
            validationSchema={schema}
            render={({values, handleChange, errors, setFieldValue, isSubmitting})=>(
                <Form noValidate>
                    <Grid item spacing={2} md={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField sx={{width:'100%'}}
                                    name="name"
                                    value={values.name}
                                    fullWidth
                                    variant="outlined"
                                    label="Nome"
                                    onChange={handleChange}
                                    error={!!errors.name}
                                    helperText={!!errors.name ? errors.name : null}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField sx={{width:'100%'}}
                                    name="email"
                                    fullWidth
                                    variant="outlined"
                                    label="Email"
                                    onChange={handleChange}
                                    value={values.email}
                                    error={!!errors.email}
                                    helperText={!!errors.email ? errors.email : null}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{display: 'flex'}}>
                                <Grid xs={6} sx={{marginRight: '1rem'}}>
                                    <TextField
                                        name="password"
                                        fullWidth
                                        variant="outlined"
                                        label="Senha"
                                        type="password"
                                        onChange={handleChange}
                                        value={values.password}
                                        error={!!errors.password}
                                        helperText={!!errors.password ? errors.password : null}
                                    />
                                </Grid>
                                <Grid xs={6}>
                                    <TextField 
                                        name="confirmPassword"
                                        fullWidth
                                        variant="outlined"
                                        label="Confirme sua Senha"
                                        onChange={handleChange}
                                        type="password"
                                        value={values.confirmPassword}
                                        error={!!errors.confirmPassword}
                                        helperText={!!errors.confirmPassword ? errors.confirmPassword : null}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sx={{display: 'flex'}}>
                                <Autocomplete
                                    value={updateRoles(values.role)}
                                    fullWidth
                                    name="role"
                                    label="Cargos"
                                    placeholder="Selecione o cargo"
                                    options={roles}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(evt, options)=>{
                                       setFieldValue('role', options.id)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    value={values.permissions}
                                    fullWidth
                                    name="permissions"
                                    label="Permissōes"
                                    options={companyPermissions}
                                    groupBy={(option) => option.moduleName}
                                    getOptionLabel={(option) => option.serviceName}
                                    onChange={(evt, options)=>{
                                        setFieldValue('permissions', options)
                                     }}
                                    disableCloseOnSelect
                                    multiple
                                />
                            </Grid>
                        </Grid>
                        <Grid item container spacing={2} sx={{marginTop: '0.5rem'}}>
                            <Grid item>
                                <Button
                                    size="large"
                                    disabled={saveButton}
                                    onClick={()=>{
                                        props.openModal()
                                    }}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <SaveButton 
                                    titulo='Salvar' 
                                    isSubmitting={isSubmitting}
                                    size='large'
                                />
                            </Grid>
                        </Grid>
                    </Grid> 
                </Form>
            )}
        />
    </Grid>
  );
}